import { rng } from './Pcg';

const nib_2_hex = '0123456789abcdef'.split('');
const hex_2_nib = nib_2_hex.reduce((map, c, i) => (map[c] = i, map), {} as Record<string, number>);

const uuid_re = /^[0-9a-f]{32}$/;

export class Uuid {
	bytes: Uint8Array;

	constructor(bytes = new Uint8Array(16)) {
		this.bytes = bytes;
	}

	toString () {
		var str = '';

		function appendHex (bytes: Uint8Array) {
			bytes.forEach(byte => {
				str += `${nib_2_hex[byte >> 4]}${nib_2_hex[byte & 0x0f]}`;
			});
		}

		appendHex(this.bytes.slice(0, 4));
		str += '-';
		appendHex(this.bytes.slice(4, 6));
		str += '-';
		appendHex(this.bytes.slice(6, 8));
		str += '-';
		appendHex(this.bytes.slice(8, 10));
		str += '-';
		appendHex(this.bytes.slice(10));
		return str;
	}

	static fromString (str: string) {
		str = str.replace(/[{}-]/g, '').toLowerCase();
		if (!uuid_re.test(str)) throw new Error('invalid UUID format');

		const bytes = new Uint8Array(16);

		for (let i = 0; i < bytes.byteLength; i++) {
			const j = i << 1;
			bytes[i] = (hex_2_nib[str[j]] << 4) | hex_2_nib[str[j + 1]];
		}

		return new Uuid(bytes);
	}

	static v7 () {
		const unix_ms = Date.now();
		const bytes = new Uint8Array(16);
		const view = new DataView(bytes.buffer);

		view.setUint32(0, Math.floor(unix_ms / 65536));
		view.setUint16(4, unix_ms);

		view.setUint32(6, rng.next());
		view.setUint32(10, rng.next());
		view.setUint16(14, rng.next());

		bytes[6] = (bytes[6] & 0x0f) | 0x70;
		bytes[8] = (bytes[8] & 0x3f) | 0x80;

		return new Uuid(bytes);
	}
}

export { Uuid as default };
